var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Admin Dashboard'}}),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('h1',[_vm._v("Coming Soon!")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/dashboard/DashboardAdmin.vue